/**
 * Updates document head per route: title (≤60), description (≤155), canonical, OG, Twitter.
 * Prevents duplicate content and improves SERP/social sharing. One <PageMeta /> in Layout.
 */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getSEOForPath, DEFAULT_OG_IMAGE } from '../../data/seo'

export function PageMeta() {
  const location = useLocation()
  const { title, description, keywords, ogImage, canonical, noIndex } = getSEOForPath(location.pathname)

  useEffect(() => {
    document.title = title
  }, [title])

  useEffect(() => {
    const setMetaName = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute('name', name)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }
    const setMetaProperty = (property: string, content: string) => {
      let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute('property', property)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }

    setMetaName('description', description)
    if (keywords) setMetaName('keywords', keywords)
    if (noIndex) setMetaName('robots', 'noindex, nofollow')
    else setMetaName('robots', 'index, follow')

    setMetaProperty('og:title', title)
    setMetaProperty('og:description', description)
    setMetaProperty('og:url', canonical)
    setMetaProperty('og:image', ogImage || DEFAULT_OG_IMAGE)
    setMetaProperty('og:type', 'website')

    setMetaProperty('twitter:card', 'summary_large_image')
    setMetaProperty('twitter:url', canonical)
    setMetaProperty('twitter:title', title)
    setMetaProperty('twitter:description', description)
    setMetaProperty('twitter:image', ogImage || DEFAULT_OG_IMAGE)

    let canonicalEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null
    if (!canonicalEl) {
      canonicalEl = document.createElement('link')
      canonicalEl.rel = 'canonical'
      document.head.appendChild(canonicalEl)
    }
    canonicalEl.href = canonical
  }, [title, description, keywords, canonical, ogImage, noIndex])

  return null
}
